<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wJyFwY/tc-custom/9780802148070.jpg?1728954665464" alt="This image is the cover for the book Small Town"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Small Town
      </h1>
      <p class="bookDescription body article font2">
        <b>A small-town cop seeks vengeance on twelve escaped inmates in this novel of “jaw-dropping twists . . . </b><b>crisp in execution and thrilling until the very end” (<i>The Wall Street Journal</i>).</b><br/>  <br/> When twelve inmates pull off an audacious prison break, it liberates more than a thousand convicts into the nearby small town. The newly freed prisoners rape, murder, and destroy the quiet community—burning down homes and businesses. An immense search ensues, but the twelve who plotted it all get away.<br/>  <br/> After two years, the local and federal police agencies have yet to find them. Then, the mayor calls in Leah Hawkins, a local cop who lost a loved one that terrible night. She’s placed on sabbatical to travel across the country learning advanced police procedures. But the sabbatical is merely a ruse. Her real job is to track down the infamous twelve—and kill them.<br/>  <br/> Leah’s mission takes her from Florida to New York and from the beaches of California to an anti-government settlement deep in the Ozarks. But when the surviving fugitives realize what she’s up to, a race to kill or be killed ensues in this nonstop tale of vengeance from the Edgar Award–winning author of <i>The Butcher’s Boy</i>.<br/>  <br/> “Leah proves to be both a brilliant detective and a cunning predator.” —<i>Associated Press</i><br/>  <br/> “Perry is an expert storyteller . . . <i>A Small Town</i> unfolds like a 1950s film noir.” —<i>Wall Street Journal</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Perry
      </h2>
      
      <p class="authorDescription body article">Thomas Perry is the bestselling author of over twenty novels, including the critically acclaimed Jane Whitefield series, <I>The Old Man</I>, and <I>The Butcher&rsquo;s Boy</I>, which won the Edgar Award. He lives in Southern California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Atlantic
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?653ca67d